import dayjs from 'dayjs';
import { invokeSaveAsDialog, RecordRTCPromisesHandler } from 'recordrtc';

import { AppDeviceLeaf } from 'types/common/leaf';

interface RecordingParams {
  leaf: AppDeviceLeaf;
}

interface RecordingReturn {
  startRecording: (remoteStream: MediaStream) => Promise<{ recorder: RecordRTCPromisesHandler; startTime: number }>;
  stopRecording: (recorder: RecordRTCPromisesHandler) => Promise<void>;
}

export const useRecording = ({ leaf }: RecordingParams): RecordingReturn => {
  const startRecording: RecordingReturn['startRecording'] = async (remoteStream) => {
    const recorder = new RecordRTCPromisesHandler(remoteStream, {
      type: 'video',
      mimeType: 'video/mp4',
      // Otherwise the console get all debug logs from RecordRTC
      disableLogs: true,
    });

    await recorder.startRecording();

    return { recorder, startTime: dayjs().unix() };
  };

  const stopRecording: RecordingReturn['stopRecording'] = async (recorder) => {
    await recorder.stopRecording();
    const blob = await recorder.getBlob();
    const dateString = dayjs().format('MM-DD-YYYY_HH-mm-ss');
    const name = `${leaf.name}_${dateString}.mp4`;
    invokeSaveAsDialog(blob, name);
  };

  return { startRecording, stopRecording };
};
